import { CORE_LINK_TRACK_VARS } from "../linkTrackVars"

/** Variables common to all purchase-request link-tracking calls (props/eVars/events), plus the core beacon variables */
export const PURCHASE_REQUEST_LINK_TRACK_VARS_BASE = `${CORE_LINK_TRACK_VARS},events,eVar17,eVar18,eVar197`
